import ICompAddress, { newCompAddress } from '../CompAddress';
import ICompFinalSourceDatas from './ICompFinalSourceDatas';
import ICompLocalVersions from '../comp/ICompLocalVersions';
import ICompNotesData from '../comp/ICompNotesData';
import ICompFinalDataSources from './ICompFinalDataSources';
import ICompFinalDataSource from './ICompFinalDataSource';
import ISalesHistory from '../sales-history/ISalesHistory';

export default interface ICompFinalProperty {
    address: ICompAddress;
    address1WithUnitNo: string;
    compKey?: string;
    compNumber: number;
    compType?: string;
    formCode: string;
    hasVisited?: boolean;
    propertyPhoto?: string;
    sourceData: ICompFinalSourceDatas;
    sourceDataDB?: ICompFinalDataSource;
    sourceDataPR?: ICompFinalDataSource;
    sourceDataSE?: ICompFinalDataSource;
    sourceDataMLS?: ICompFinalDataSource;
    sourceDataFF?: ICompFinalDataSource;
    salesHistory?: ISalesHistory
    localVersions: ICompLocalVersions;
    notesData: ICompNotesData;
    sources: ICompFinalDataSources;
}

export function newCompFinalProperty(): ICompFinalProperty {
    const result: ICompFinalProperty = {
        address: newCompAddress(),
        address1WithUnitNo: '',
        compNumber: NaN,
        formCode: '',
        sourceData: [],
        localVersions: [],
        notesData: [],
        sources: []
    };
    return result;
}
